import React from "react";

import { racehorse360 } from "@tsg/1st-grpc-web-rh360";

import { getPersonFullName } from "utils/person";
import ErrorBoundary from "components/ErrorBoundary";
import Loader from "components/Loader";
import Popover from "components/Popover";
import CommentItem from "./CommentItem";

import useStyles from "./styles";

export interface IPopoverItem {
  id: string;
  body: string;
  updatedBy: racehorse360.IUser;
  updatedOn: string;
}

export type ICommentsPopoverData = IPopoverItem | IPopoverItem[];

interface IProps {
  data: ICommentsPopoverData;
  anchorElement: HTMLElement;
  isLoadingData: boolean;
  onClose: () => void;
}

const CommentsPopover = (props: IProps) => {
  const { data, onClose, isLoadingData, anchorElement } = props;
  const preparedData = Array.isArray(data) ? data : [data];

  const classes = useStyles();

  const renderComments = (comment: IPopoverItem, index: number) => {
    const { updatedOn, updatedBy, body } = comment;

    return (
      <CommentItem
        key={index}
        body={body}
        updatedOn={updatedOn}
        commentatorName={getPersonFullName(updatedBy)}
      />
    );
  };

  const renderContent = () => {
    if (isLoadingData) return <Loader className={classes.popoverLoader} />;

    return (
      <div className={classes.commentsContainer}>
        {preparedData.map(renderComments)}
      </div>
    );
  };

  return (
    <ErrorBoundary>
      <Popover anchorEl={anchorElement} onClose={onClose}>
        {renderContent()}
      </Popover>
    </ErrorBoundary>
  );
};

export default React.memo(CommentsPopover);
